import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import { updateComment } from '../../actions/update-comment';
import goBack from '../../actions/go-back';
import { fetchPostAndRedirect } from '../../actions/fetch-post-and-redirect';
import { redirectTo404 } from '../../actions/redirect-to-404';
import { fetchComment } from '../../actions/fetch-comment';
import AppLoaded from '../../components/app-loaded';
import PostPageLayout from '../../components/post-page-layout';
import CommentForm from '../../components/comment-form';
import CommentFormWrapper from '../../components/comment-form-wrapper';
import messages, { COMMENT_UPDATE } from '../../components/message/messages';
import { getPostBySlug } from '../../selectors/post-selectors';
import { getComment } from '../../selectors/comment-selectors';
import withEnvironment from '../../hoc/with-environment';

export class CommentEditPage extends Component {
  static fetchData = ({ store, params: { categorySlug, postSlug, commentId }, search }) =>
    store
      .dispatch(fetchPostAndRedirect(categorySlug, postSlug, search))
      .then(post =>
        store.dispatch(
          fetchComment({
            postId: post._id,
            commentId,
          })
        )
      )
      .catch(error => {
        if (error.status === 401) {
          return store.dispatch(
            push({
              pathname: `/login${search}&redirect=/${categorySlug}/${postSlug}`,
            })
          );
        } else {
          return store.dispatch(redirectTo404(search));
        }
      });

  handleSubmit = values => {
    const { comment, updateComment, showMessage, goBack } = this.props;
    updateComment({ ...comment, ...values })
      .then(() => showMessage(messages[COMMENT_UPDATE].content(), messages[COMMENT_UPDATE].type))
      .then(goBack);
  };

  render = () => {
    const { comment, goBack } = this.props;

    return (
      <PostPageLayout className="comment-edit-page">
        <CommentFormWrapper>
          <CommentForm initialValues={comment} onSubmit={this.handleSubmit} onCancel={goBack}/>
        </CommentFormWrapper>
        <AppLoaded/>
      </PostPageLayout>
    );
  };
}

CommentEditPage.propTypes = {
  comment: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { params: { postSlug, commentId } }) => {
  const post = getPostBySlug(state, postSlug);
  return {
    comment: getComment(state, commentId, post._id),
  };
};

const mapDispatchToProps = {
  goBack,
  updateComment,
};

export default _.flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' })
)(CommentEditPage);



// WEBPACK FOOTER //
// ./app/containers/comment-edit-page/comment-edit-page.js